import { createStyles, makeStyles, styled, Theme } from "@material-ui/core/styles";
import * as React from "react";
import * as ThemeConstants from "../../Styles/Constants";
import { GameType, useGameContext } from "../GameContext/GameContext";
import { OriginalGameParamsList } from "../UI/Games/OriginalGame/OriginalGameParamsList";
import { OriginalGamePage } from "./Games/OriginalGamePage";
import { LobbyPage } from "./LobbyPage";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {

        }
    })
);

export const GamePage = () => {
    const classes = useStyles();
    const gameContext = useGameContext();

    const renderGame = () => {
        switch (gameContext.gameType) {
            default: return <></>
            case GameType.Original: return <OriginalGamePage />
        }
    }

    const renderParameters = () => {
        switch (gameContext.gameType) {
            default: return <></>
            case GameType.Original: return <OriginalGameParamsList />
        }
    }

    return (
        <div className={classes.root}>
            {gameContext.gameState.lobbyOpen ?
                <LobbyPage maxPlayers={10} renderParameters={renderParameters} />
                :
                renderGame()
            }
        </div>
    );
}